module.exports = __webpack_public_path__ + "static/media/search.5edb7da3.svg";